import moment from 'moment';

import * as types from '@/store/mutation-types';
import api from '@/store/api';
import log from '@/logger';

import { logAction } from '../logActions';

export const fetchCompanies = async () => {
  return api.fetchCompanies();
};

export const updateStateCompanies = async ({ commit }) => {
  commit(types.setSyncStatus, { status: 'Active', live: 0, message: 'Loading companies', progress: 30 });
  commit(types.setCompanyList, await api.fetchCompanies());
};

export const getDefaultCompany = async () => {
  return api.prepareCompanyEntity();
};

export const addSyncedCompany = ({ commit }, company) => {
  commit(types.addCompany, { newCompany: api.upgradeCompanyDocument(company) });
};

export const mailCompanyRegistrationLink = ({ dispatch }, { company, link, email }) => {
  const links = company.registrationLinks.map((item) => {
    return link._id === item._id ? { ...item, linkMailTo: email } : { ...item };
  });

  return dispatch('saveCompanyProperties', {
    updateCompany: company,
    newCompanyProperties: { registrationLinks: links },
  });
};

export const mailCompanyMissingFilesReminder = ({ dispatch }, { company, email, projectIds }) => {
  const missingFilesReminder = { email, projectIds };
  return dispatch('saveCompanyProperties', { updateCompany: company, newCompanyProperties: { missingFilesReminder } });
};

export const addCompanyRegistrationLink = ({ dispatch }, { company, project }) => {
  let linkList = Object.assign([], company.registrationLinks) || [];
  if (linkList.find((e) => e.projectId === project._id && moment(e.expiryDate).isAfter(moment()))) {
    return;
  }
  linkList.push({
    projectId: project._id,
    link: '',
    linkMailTo: '',
    expiryDate: moment().add(999, 'days').format('YYYY-MM-DD'),
  });
  return dispatch('saveCompanyProperties', {
    updateCompany: company,
    newCompanyProperties: { registrationLinks: linkList },
  });
};

export const addCompany = ({ commit, state }, addInfo) => {
  log.debug('companyActions:addCompany', addInfo);

  if (!addInfo.newCompanyProperties) {
    addInfo.newCompanyProperties = {};
  }

  return api
    .createCompany(addInfo.newCompanyProperties)
    .then((company) => {
      // setCompanyProperties({commit, state}, {updateCompany: company, newCompanyProperties: addInfo.newCompanyProperties});
      logAction({ commit, state }, { object: company, reason: 'Added Company' });
      commit(types.addCompany, { newCompany: company });

      return company;
    })
    .catch((e) => {
      log.error('companyActions:createCompany', e);
      commit(types.setSyncStatus, {
        status: 'Error',
        live: 0,
        message: 'Database Error occurred while adding company',
        count: 1,
      });
    });
};

export const deleteCompany = ({ commit, state, dispatch }, { company }) => {
  dispatch('saveCompanyProperties', {
    updateCompany: state.companies[company._id],
    newCompanyProperties: { archived: true },
  }).then(() => {
    commit(types.deleteCompany, { company });
  });
};

export const saveCompanyProperties = ({ commit, state }, update) => {
  log.debug('companyActions:saveCompanyProperties', update);

  logAction(
    { commit, state },
    { object: update.updateCompany, reason: 'Updated Company Properties', update: update.newCompanyProperties }
  );
  setCompanyProperties({ commit, state }, update);

  return api
    .saveCompany(update.updateCompany)
    .then((savedCompany) => {
      update.newCompanyProperties = savedCompany;

      commit(types.setCompanyProperties, update);
      return update.updateCompany;
    })
    .catch((e) => {
      log.error('companyActions:saveCompanyProperties', e);
      commit(types.setSyncStatus, {
        status: 'Error',
        live: 0,
        message: 'Database Error occurred while saving company properties',
        count: 1,
      });
    });
};

export const setCompanyProperties = ({ commit }, update) => {
  log.debug('companyActions:setCompanyProperties', update);
  commit(types.setCompanyProperties, update);
};

export const syncCompanyProperties = ({ commit }, update) => {
  commit(types.setCompanyProperties, update);
};



// WEBPACK FOOTER //
// ./src/store/company/companyActions.js